import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GlobalStatusParams } from 'src/app/shared/models/iCourrier/status-management/global-status';
import { GlobalStatusDTO } from '../interfaces/global/global-status.interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GlobalSpecificStatutesService {
  private iCourrierURL;

  constructor(private http: HttpClient) {
    const config = environment;
    this.iCourrierURL = config.apiICourrierBaseUrl;
  }

  getGlobalStatus(data?: GlobalStatusParams): Observable<GlobalStatusDTO[]> {
    let params = new HttpParams();
    if (data) {
      Object.keys(data).forEach((key) => (params = params.set(key, data[key])));
    }
    return this.http.get<GlobalStatusDTO[]>(`${this.iCourrierURL}/Global/GlobalStatutes?${params}`);
  }
}
